export const HeroCalculatorTexts = {
  eventLabelPage: 'Лендинг подбора',
};
